import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonSelectorData } from '../button-selector/button-selector-data';

@Component({
  selector: 'app-tipo-pessoa',
  templateUrl: './tipo-pessoa.component.html',
  styleUrls: ['./tipo-pessoa.component.css'],
})
export class TipoPessoaComponent implements OnInit {
  @Output() tipoPessoaChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() initialTipoPessoa: string;
  @Input() tipoCliente: ButtonSelectorData = new ButtonSelectorData();
  @Input() tiposClientes: ButtonSelectorData[];

  ngOnInit() {
    if (this.initialTipoPessoa) {
      const selected = this.tiposClientes.find(
        (item) => item.id === this.initialTipoPessoa
      );

      if (selected) {
        this.tipoCliente = selected;
        this.onTipoClienteChange();
      }
    }
  }

  onTipoClienteChange() {
    this.tipoPessoaChange.emit(this.tipoCliente.id);
  }
}
